import React from 'react';

const ExternalJobboardLogo = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="15.4102"
      y="5"
      width="15.5002"
      height="21.8826"
      rx="2"
      transform="rotate(8.96372 15.4102 5)"
      fill="#F8D372"
    />
    <rect
      x="15.4102"
      y="5"
      width="15.5002"
      height="21.8826"
      rx="2"
      transform="rotate(8.96372 15.4102 5)"
      fill="url(#paint0_linear_7572_5373)"
    />
    <path
      d="M13.0285 6.89744C12.7347 5.84472 11.6501 5.22285 10.5932 5.50099L4.9616 6.98293C3.88212 7.267 3.2441 8.3797 3.54421 9.45482L8.47037 27.1021C8.76423 28.1548 9.84874 28.7767 10.9057 28.4985L16.537 27.0166C17.6165 26.7325 18.2545 25.6198 17.9544 24.5447L13.0285 6.89744Z"
      fill="url(#paint1_linear_7572_5373)"
    />
    <rect
      x="1"
      y="8.12109"
      width="15.9202"
      height="22.4756"
      rx="2"
      transform="rotate(-15 1 8.12109)"
      fill="#DFB853"
    />
    <rect x="7" y="3" width="18" height="25" rx="2" fill="#F6E1AC" />
    <rect x="7" y="3" width="18" height="25" rx="2" fill="#F6E2B1" />
    <path d="M7 5C7 3.89543 7.89543 3 9 3H16V28H9C7.89543 28 7 27.1046 7 26V5Z" fill="#F2DA9C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3635 15.8182V16.6364H12.0908C11.5385 16.6364 11.0908 17.0841 11.0908 17.6364V23C11.0908 23.5523 11.5385 24 12.0908 24H19.909C20.4613 24 20.909 23.5523 20.909 23V17.6364C20.909 17.0841 20.4613 16.6364 19.909 16.6364H17.6363L17.6363 15.8182V15H16.8181H15.1817H14.3635V15.8182ZM16.8181 15.8182H15.1817V16.6364H16.8181V15.8182Z"
      fill="#FFC42E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3635 15.8182V16.6364H12.0908C11.5385 16.6364 11.0908 17.0841 11.0908 17.6364V23C11.0908 23.5523 11.5385 24 12.0908 24H19.909C20.4613 24 20.909 23.5523 20.909 23V17.6364C20.909 17.0841 20.4613 16.6364 19.909 16.6364H17.6363L17.6363 15.8182V15H16.8181H15.1817H14.3635V15.8182ZM16.8181 15.8182H15.1817V16.6364H16.8181V15.8182Z"
      fill="url(#paint2_linear_7572_5373)"
    />
    <path d="M20 13H12L10 8L14 10L16 7L18 10L22 8L20 13Z" fill="#FFC42E" />
    <defs>
      <linearGradient
        id="paint0_linear_7572_5373"
        x1="20.6186"
        y1="11.7712"
        x2="28.5209"
        y2="10.5247"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A87B06" />
        <stop offset="1" stopColor="#A87B06" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7572_5373"
        x1="10.4985"
        y1="12.0002"
        x2="3.22119"
        y2="13.5002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A87B06" />
        <stop offset="1" stopColor="#A87B06" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7572_5373"
        x1="13.5454"
        y1="8.45455"
        x2="16.8181"
        y2="21.5455"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F85D72" />
        <stop offset="1" stopColor="#F85D72" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default ExternalJobboardLogo;
